<template>
  <div class="plan">
    <div class="plan-title">{{title}}</div>
    <div class="plan-list">
      <template v-for="(item, index) in list">
        <a :href="item.introUrl" class="plan-list-item" :key="index">
          <span class="name">{{item.shortname}}</span>
          <span class="detail">查看详情 >></span>
        </a>
      </template>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PlanItem',
    props: {
      title: {
        type: String,
        default: '',
      },
      list: {
        type: Array,
        default() {
          return [];
        },
      },
    },
  };
</script>

<style lang="scss" scoped>
@import "~assets/scss/mixins";

.plan {
  box-sizing: border-box;
  padding: 0 14px;
  width: 100%;
  height: 85px;
  background-color: #fff;
  border: 1px solid $border-color;
  border-radius: 8px;
  @include flex-between(column);

  &-title {
    width: 100%;
    font-size: 14px;
    color: #333;
    text-align: center;
    line-height: 35px;
    border-bottom: 1px solid $border-color;
  }

  &-list {
    flex: 1;
    width: 100%;
    @include flex-center();
  }

  &-list-item {
    padding: 0 15px;
    flex: 1;
    font-size: 12px;
    color: #666;
    line-height: 26px;
    @include flex-between();

    .detail {
      color: #fe563e;
    }

    & + & {
      border-left: 1px solid $border-color;
    }
  }
}
</style>
